

var article = `

**NOTA:** si los repositorios son de la distribución [Ubuntu](https://ubuntu.com/download/desktop), servirán solamente para ésta y las distros basadas en la misma, como [Kubuntu](https://kubuntu.org/getkubuntu/), [Lubuntu](https://lubuntu.net/downloads/), etc.

## Configurar los repositorios

Abrir el archivo **sources.list**:

> **juan@linux:~$** sudo nano /etc/apt/sources.list

Se abre el editor **nano** y si hay repositorios de otra distribución los *eliminamos* o *comentamos*.

Para comentar se utiliza la almohadilla o numeral **#**, y éstos *no serán tenidos en cuenta* por el sistema.

Por ejemplo:

> **\\#** deb http://us.archive.ubuntu.com/ubuntu/ **bionic** main restricted
> **\\#** deb-src http://us.archive.ubuntu.com/ubuntu/ **bionic** main restricted
> **\\#** deb http://us.archive.ubuntu.com/ubuntu/ **bionic-updates** main restricted
> **\\#** deb-src http://us.archive.ubuntu.com/ubuntu/ **bionic-updates** main restricted
>
> **\\#** deb https://ejemplo.com/... ... .... .... .... ....
> **\\#** deb-src https://ejemplo.com/... ... .... .... .... ....

Ahora solamente queda agregar la **nueva lista de repositorios**.

**NOTA:** para **conseguir la lista de repositorios** ir a este enlace sobre [actualizar linux cambiando los repositorios](/blog/actualizar-linux-cambiando-los-repositorios).

Por ejemplo, agrego los *repos* de la distro **Jammy**:

> deb http://us.archive.ubuntu.com/ubuntu/ **jammy** main restricted
> deb-src http://us.archive.ubuntu.com/ubuntu/ **jammy** main restricted
> deb http://us.archive.ubuntu.com/ubuntu/ **jammy-updates** main restricted
> deb-src http://us.archive.ubuntu.com/ubuntu/ **jammy-updates** main restricted
>
> deb https://ejemplo.com/... ... .... .... .... ....
> deb-src https://ejemplo.com/... ... .... .... .... ....

### Guardar los cambios

Cerrar el editor con **Ctrl + X**

Acepto guardar los cambios y guardarlo con el mismo nombre (**sources.list**).

### Actualizar el sistema

Por consola hacer:

> **juan@linux:~$** sudo apt update

> **juan@linux:~$** sudo apt upgrade

Si hay problemas:

* Ver este enlace de [problemas con repositorios y clave pública](/blog/problemas-con-repositorios-y-clave-publica-linux).
`

export default article